import React from "react";
import { useVisibilityTransition } from "./hooks/useVisibilityTransition";

interface IVisibilityTransition {
  active: boolean;
  children: React.ReactNode;
  delay?: number;
}

export const VisibilityTransition = ({ active, children, delay }: IVisibilityTransition) => {
  const shouldRenderChild = useVisibilityTransition(active, delay);

  if (!shouldRenderChild) {
    return null;
  }

  return <>{children}</>;
};
